import { render } from "./SDV_Discrepancymodal.vue?vue&type=template&id=12114e43"
import script from "./SDV_Discrepancymodal.js?vue&type=script&lang=js"
export * from "./SDV_Discrepancymodal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__